<template>
   <!-- ℹ️ This component is used to display documents that are not part of any study. -->
   <section
      v-if="section.subsections.length"
      class="account-section"
      data-cy="account-section"
      :aria-labelledby="`account-section-${index}-heading`"
   >
      <h2
         :id="`account-section-${index}-heading`"
         class="h3 mb-6 max-w-80ch text-brand-dark"
         data-cy="account-section-heading"
      >
         {{ section.heading }}
      </h2>
      <RichTextRenderer
         v-if="section.description"
         class="max-w-80ch"
         :document="section.description"
         data-cy="account-section-description"
      />
      <div class="account-section-group" data-cy="account-section-group">
         <template v-for="subsection in section.subsections" :key="`account-page-subsection-${subsection.type}`">
            <component :is="accountSectionComponents[subsection.type]" :subsection="subsection"></component>
         </template>
      </div>
   </section>
</template>
<script setup lang="ts">
import { type AccountSection } from "./accountTypes";

// Dynamic section components
// -----------------------------------------
import AccountSubsection from "./AccountSubsection.vue";
import UserStudies from "./userStudies/UserStudies.vue";
import UserDocuments from "./userDocuments/UserDocuments.vue";
import UserContributions from "./UserContributions.vue";

const accountSectionComponents = {
   account_subsection: AccountSubsection,
   user_studies_subsection: UserStudies,
   user_documents_subsection: UserDocuments,
   external_contributions_subsection: UserContributions,
};

// Props
// ------------------------------------
const props = defineProps<{
   section: AccountSection;
   index: number;
}>();
</script>
<style lang="scss" scoped>
// Hide the whole section if no items are present
// Particularly useful to hide "General documents" section if no documents are present
.account-section:has(.account-section-group:empty) {
   display: none;
}
</style>
